__turbopack_context__.v({
  "app": "App-module-scss-module__GdYkYq__app",
  "isMobileClient": "App-module-scss-module__GdYkYq__isMobileClient",
  "line-break": "App-module-scss-module__GdYkYq__line-break",
  "text-align_center": "App-module-scss-module__GdYkYq__text-align_center",
});
